import React from 'react';

import Workspace from '~/App/Modules/Workspaces/Types/Workspace';

export interface WorkspaceContextProps {
  workspaces?: Workspace[];
  selected: string | null;
  selectedWorkspace?: Workspace | null;
  setWorkspace: (workspace: Workspace | null | undefined) => any;
}

export default React.createContext<WorkspaceContextProps>({
  workspaces: [],
  selected: null,
  selectedWorkspace: null,
  setWorkspace: () => {
    /* noop */
  },
});
